import { ExamStatesValue, ExamStatesLabel } from "./constants"
/**
 * 检查状态格式工具
 * @param {*} val 
 */
export function Formatter_examStatesFormatter( val ) {
  for( let key in ExamStatesValue) {
    if(ExamStatesValue[key] == val ) return ExamStatesLabel[key]
  }
  return ''
}


export const Formatter_ageFormatter = (age) => {  
  const today = new Date();  
  const birthDate = new Date(age);  
  let years = today.getFullYear() - birthDate.getFullYear();  
  const monthDiff = today.getMonth() - birthDate.getMonth();  
  const dayDiff = today.getDate() - birthDate.getDate();  

  // Adjust the age if the birthday hasn't occurred yet this year  
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {  
    years--;  
  }  

  return years;  
};